import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import api from "@/lib/api";
import { errMsg } from "@/components/attendance/ui";

export default function UsherQrClaim() {
  const { qr } = useParams();
  const nav = useNavigate();
  const [err, setErr] = useState(null);
  const once = useRef(false);
  useEffect(() => {
    if (once.current) return;
    once.current = true;
    api.post(`/attendance/usher-qr/${qr}/claim`)
      .then((r) => nav(`/attendance/u/${r.data.token}`, { replace: true }))
      .catch((e) => setErr(errMsg(e, "This QR code is not valid.")));
  }, [qr, nav]);
  return (
    <div className="min-h-[100svh] bg-[#0A0A0A] flex items-center justify-center px-6 text-center" data-testid="usher-qr-claim">
      {err ? <p className="text-neutral-300" data-testid="usher-qr-error">{err}</p> : <Loader2 className="animate-spin text-[#D4AF37]" />}
    </div>
  );
}
